// Pricing strategy selector + the editor that matches the chosen strategy.
// Lets an admin pick how a product/option is priced (currently tiered per
// sq-mi or a flat price) and edit the values for that strategy. Controlled by
// the surrounding editor slice — strategy/tiers/flatAmount and their setters
// are passed in. New strategies slot in by adding a config entry + a branch.
import {
  Box, Typography, ToggleButton, ToggleButtonGroup,
} from '@mui/material';
import { PRICING_STRATEGIES, STRATEGY_OPTIONS, STRATEGY_HELP } from '../../config/pricing-strategies.js';
import TieredPricingEditor from './TieredPricingEditor.jsx';
import FlatPriceEditor from './FlatPriceEditor.jsx';

const PricingStrategySection = ({
  strategy,
  onStrategyChange,
  tiers,
  onTiersChange,
  flatAmount,
  onFlatAmountChange,
}) => {
  const handleStrategy = (event, next) => {
    if (next != null) onStrategyChange(next);
  };

  const renderEditor = () => {
    if (strategy === PRICING_STRATEGIES.CUSTOM_QUOTE) {
      return (
        <Typography variant="body2" color="text.secondary">
          This product is always priced manually. No rate is set here — selecting it
          on the form asks the customer for a custom quote instead of an estimate.
        </Typography>
      );
    }
    if (strategy === PRICING_STRATEGIES.FLAT) {
      return <FlatPriceEditor amount={flatAmount} onChange={onFlatAmountChange} />;
    }
    return <TieredPricingEditor tiers={tiers} onChange={onTiersChange} />;
  };

  return (
    <Box>
      <Typography component="span" variant="subtitle2" sx={{ display: 'block', mb: 0.5 }}>
        Pricing strategy
      </Typography>
      <ToggleButtonGroup
        exclusive
        size="small"
        color="primary"
        value={strategy}
        onChange={handleStrategy}
        sx={{ mb: 0.5, flexWrap: 'wrap' }}
        aria-label="Pricing strategy"
      >
        {STRATEGY_OPTIONS.map((opt) => (
          <ToggleButton key={opt.value} value={opt.value}>
            {opt.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
        {STRATEGY_HELP[strategy]}
      </Typography>

      {renderEditor()}
    </Box>
  );
};

export default PricingStrategySection;
